/* The Mint Workshop — bottom dock.
   Rises once the hero action has scrolled out of view, and retracts over the
   real footer so it never sits on top of it. Fails open: without JS the dock
   stays hidden and the page behaves normally. */
(function () {
  'use strict';

  var dock = document.querySelector('[data-mw-dock]');
  if (!dock || !('IntersectionObserver' in window)) return;

  var mq = window.matchMedia('(max-width: 900px)');
  var pastHero = false;
  var atFooter = false;

  function apply() {
    var show = mq.matches && pastHero && !atFooter;
    dock.classList.toggle('is-up', show);
    dock.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function arm(on) {
    dock.classList.toggle('is-armed', on);
    if (!on) { dock.classList.remove('is-up'); }
    else apply();
  }

  // rise once the hero's own button has left the screen
  var trigger = document.querySelector('[data-mw-cta-source]')
             || document.querySelector('.mw-mat__cta, .mw-mhero__cta');
  if (trigger) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
        apply();
      });
    }, { threshold: 0 }).observe(trigger);
  } else {
    pastHero = true;
  }

  /* Retract before it can cover the footer. Measured on scroll rather than
     observed, because the footer element can be re-rendered — an observer
     holding a stale reference silently stops firing. */
  function checkFooter() {
    var f = document.querySelector('.mw-ftr');
    if (!f) { atFooter = false; return; }
    var r = f.getBoundingClientRect();
    var dockTop = window.innerHeight - dock.offsetHeight - 8;
    atFooter = r.top < dockTop;
    apply();
  }

  window.addEventListener('scroll', checkFooter, { passive: true });
  window.addEventListener('resize', checkFooter, { passive: true });
  checkFooter();

  arm(mq.matches);
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (e) {
    arm(e.matches);
  });
})();
